import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Button } from '@mui/material';
import { firestore } from '../Firebase/utils';

const mapState = ({ user }) => ({
    currentUser: user.currentUser
})


export default function ChatMessage(props) {
    const { text, uid, userName, createdAt, id } = props.message;
    const { currentUser } = useSelector(mapState)
    const [user, setUser] = useState(currentUser)
    const [myMessage, setMyMessage] = useState(false)
    const date = new Date(createdAt.seconds * 1000)

    useEffect(() => {
      setMyMessage(uid === user.uid)
    }, [user])
  
    return (
        <Grid container justifyContent={myMessage ? 'flex-end' : 'flex-start'}>
          <Grid flexDirection='column' backgroundColor={myMessage ? '#36BAFE' : '#262A34'} sx={{my: .3, borderRadius: 2, padding: .5, width: {xs:'75%', md:'55%'}, color: '#FFF'}}>
            <Grid container justifyContent='space-between' sx={{}}>
              <Grid item >
                <Typography color={myMessage ? '#FFF' : '#BE6DDD'} fontSize={{xs:12, md:12}} fontWeight='bold'>{userName + ':' + " "}</Typography>
              </Grid>
              <Grid item >
                <Typography fontSize={{xs:12, md:12}}>{date.toDateString()}</Typography>
              </Grid>
            </Grid>
            <Grid>
              <Typography fontSize={{xs:12, md:12}}>{text}</Typography>
            </Grid>
            {/* {myMessage && <Button sx={{fontSize:10, color:'#F00'}} onClick={() => {firestore.collection('messages').doc(props.id).delete()}}>Delete</Button>} */}
          </Grid>
        </Grid>)
  }
